import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Chip, ErrorMessage, Input } from "@components/atoms";
import { Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import Spinner from "../../../../images/spinner.svg";
import * as S from "./styles";
export var DiscountForm = function DiscountForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      discount = _ref.discount,
      errors = _ref.errors,
      formId = _ref.formId,
      formRef = _ref.formRef,
      promoCodePending = _ref.promoCodePending,
      onClose = _ref.onClose;
  var intl = useIntl();
  var promoCode = discount === null || discount === void 0 ? void 0 : discount.promoCode;
  return React.createElement(Formik, {
    initialValues: {
      errors: errors,
      formikPromoCode: ""
    },
    enableReinitialize: true,
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting,
          resetForm = _ref2.resetForm;

      if (handleSubmit) {
        handleSubmit({
          promoCode: values.formikPromoCode
        });
        resetForm();
      }

      setSubmitting(false);
    }
  }, function (_ref3) {
    var _values$formikPromoCo;

    var handleChange = _ref3.handleChange,
        handleSubmitFormik = _ref3.handleSubmit,
        values = _ref3.values;
    var hasErrors = !!(values.errors && values.errors.length);
    return React.createElement(S.DiscountForm, {
      id: formId,
      ref: formRef,
      onSubmit: handleSubmitFormik
    }, !promoCode && React.createElement(S.Input, null, React.createElement(S.InputWithButton, null, React.createElement(S.InputWrapper, null, React.createElement(Input, {
      "data-cy": "checkoutPaymentPromoCodeInput",
      error: hasErrors,
      name: "formikPromoCode",
      value: values.formikPromoCode,
      label: intl.formatMessage(_defineProperty({
        defaultMessage: "Enter promo code",
        "id": "@next.components.organisms.DiscountForm.DiscountForm.2481366264"
      }, "id", "@next.components.organisms.DiscountForm.DiscountForm.2481366264")),
      onChange: handleChange
    })), React.createElement(S.ButtonWrapper, null, React.createElement(S.StyledButton, {
      type: "submit",
      "data-cy": "checkoutPaymentPromoCodeBtn",
      active: ((_values$formikPromoCo = values.formikPromoCode) === null || _values$formikPromoCo === void 0 ? void 0 : _values$formikPromoCo.length) > 0
    }, React.createElement(S.Spinner, {
      src: Spinner,
      cHidden: promoCodePending,
      alt: ""
    }), !promoCodePending ? intl.formatMessage(_defineProperty({
      defaultMessage: "Apply",
      "id": "@next.components.organisms.DiscountForm.DiscountForm.3476123"
    }, "id", "@next.components.organisms.DiscountForm.DiscountForm.3476123")) : null))), React.createElement(ErrorMessage, {
      errors: values.errors
    })), promoCode && React.createElement(S.PromoCodeValue, null, React.createElement("span", null, intl.formatMessage(_defineProperty({
      defaultMessage: "Promo code:",
      "id": "@next.components.organisms.DiscountForm.DiscountForm.2325139416"
    }, "id", "@next.components.organisms.DiscountForm.DiscountForm.2325139416"))), React.createElement(S.ChipsWrapper, null, React.createElement(Chip, {
      onClose: onClose
    }, React.createElement("span", {
      "data-cy": "checkoutPaymentPromoCodeChip"
    }, promoCode)))));
  });
};